import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "../App";
import { LOGOS } from "../images";

const LANGS = ["fr", "de", "en"];

export default function Legal({ type }) {
  const { lang, setLang, t } = useLang();
  const doc = t.legal[type];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [type]);

  return (
    <div data-testid={`legal-${type}-page`} className="min-h-screen bg-ivory px-6 py-8 text-ink md:px-12 lg:px-20">
      <div className="flex items-center justify-between border-b border-ink/10 pb-6">
        <Link to="/" data-testid="legal-logo-link" aria-label="FLEN Immobilier">
          <img src={LOGOS.horizontal} alt="FLEN Immobilier" className="h-9 w-auto" />
        </Link>
        <div className="flex items-center gap-2 text-[11px] tracking-[0.2em] text-ink/60" data-testid="legal-language-switcher">
          {LANGS.map((l, i) => (
            <span key={l} className="flex items-center gap-2">
              {i > 0 && <span className="text-ink/25">|</span>}
              <button
                data-testid={`legal-lang-switch-${l}`}
                onClick={() => setLang(l)}
                className={`uppercase transition-colors duration-300 ${lang === l ? "font-semibold text-bronze" : "hover:text-ink"}`}
              >
                {l}
              </button>
            </span>
          ))}
        </div>
      </div>

      <div className="mx-auto max-w-3xl py-16 md:py-24">
        <Link
          to="/"
          data-testid="legal-back-home"
          className="group inline-flex items-center gap-3 text-[11px] font-medium uppercase tracking-[0.25em] text-ink/50 transition-colors duration-300 hover:text-bronze"
        >
          <ArrowLeft size={14} className="transition-transform duration-500 group-hover:-translate-x-1" />
          {t.legal.backHome}
        </Link>
        <h1 className="mt-12 font-serif text-4xl font-medium leading-tight md:text-5xl">{doc.title}</h1>
        <p className="mt-4 text-[11px] uppercase tracking-[0.25em] text-ink/40">{t.legal.updated}</p>
        {doc.sections.map((s, i) => (
          <section key={i} data-testid={`legal-section-${i + 1}`} className="mt-14">
            <h2 className="font-serif text-2xl font-medium">{s.h}</h2>
            <p className="mt-5 text-sm font-light leading-relaxed text-ink/70">
              {s.p.split("\n").map((line, j) => (
                <span key={j}>
                  {line}
                  <br />
                </span>
              ))}
            </p>
          </section>
        ))}
      </div>

      <div className="border-t border-ink/10 pt-6 text-[12px] font-light text-ink/40">{t.footer.rights}</div>
    </div>
  );
}
